<template>
    <BasicPage title="対応通貨リスト">
        <el-input v-model="searchText" style="width: 20rem" placeholder="BTC, Bitcoin" />
        <el-table :data="pagedTableData">
            <el-table-column label="Symbol" prop="symbol" align="left" />
            <el-table-column label="Name" prop="name" align="left" />
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="fillteredCoins.length"
            :page-size="pageSize"
            :current-page="page"
            @current-change="setPage"
        />
    </BasicPage>
</template>

<script>
import BasicPage from '@/components/BasicPage.vue';

export default {
    name: 'Coins',
    components: { BasicPage },
    layout: 'default',
    data() {
        return {
            coins: [],
            searchText: '',
            page: 1,
            pageSize: 50,
        };
    },
    computed: {
        fillteredCoins() {
            this.setPage(1);

            return this.coins.filter((v) => {
                if (this.searchText === '') {
                    return true;
                }

                const searchList = this.searchText.split(',').map((char) => char.toLowerCase().trim());

                for (const search of searchList) {
                    if (v.symbol.toLowerCase().includes(search) || v.name.toLowerCase().includes(search)) {
                        return true;
                    }
                }

                return false;
            });
        },
        pagedTableData() {
            return this.fillteredCoins.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },
    },
    async created() {
        const response = await this.$store.dispatch('apiRequest', {
            url: `/coins`,
            method: 'get',
        });

        this.coins = response.data;
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
    },
};
</script>
